export default __webpack_public_path__ + "static/media/NoTransactions.7e95567c.svg";